import { render, staticRenderFns } from "./IconPicture.vue?vue&type=template&id=737167cd&"
import script from "./IconPicture.vue?vue&type=script&lang=js&"
export * from "./IconPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports